export default (theme) => ({
  floorStyle: {
    minWidth: theme.defaults.content.pageMinWidth - 240,
    display: 'flex',
    flexDirection: 'column',
  },
  floorStyleUpcoming: {
    minWidth: theme.defaults.content.pageMinWidth - 240,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
  },
  headlineText: {
    fontWeight: 300,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'none',
  },
  root: {
    display: 'flex',
    height: 'calc(100vh - 249px)',
    flexWrap: 'nowrap',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    padding: '0px 5px 32px 5px',
    '@media (max-width: 769px)': {
      justifyContent: 'left',
    },
    boxShadow: 'none',
    borderRadius: 20,
    zIndex: 1,
    minWidth: 200,
    marginBottom: theme.spacing(3),
  },
  upcomingRoot: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginLeft: 'auto',
    marginRight: 'auto',
    overflow: 'auto',
    padding: '0px 5px 32px 5px',
    '@media (max-width: 769px)': {
      justifyContent: 'left',
    },
    width: '100%',
    boxShadow: 'none',
    zIndex: 1,
    minWidth: 200,
  },
  headlineIcon: {
    maxHeight: theme.spacing(4),
    maxWidth: theme.spacing(4),
    width: 'auto',
    height: 'auto',
    marginRight: theme.spacing(1),
    marginBottom: 4,
    color: theme.palette.icon.main,
  },
  fabStyle: {
    position: 'fixed',
    bottom: theme.spacing(8),
    right: theme.spacing(8),
    zIndex: 1,
  },
  fabStyle2: {
    position: 'fixed',
    bottom: theme.spacing(8),
    right: theme.spacing(18),
    zIndex: 1,
  },
  appBarWrapper: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    width: '100%',
    zIndex: 2,
  },
  appBar: {
    background: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.border.main}`,
    top: theme.defaults.headers.headerHeight,
    width: '100%',
  },
  schTxnForm: {
    position: 'sticky',
    top: theme.defaults.headers.headerHeight + 50,
    marginTop: 15,
    minWidth: 400,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,

    '@media (max-width: 769px)': {
      minWidth: 340,
    },
  },
  shadowBar: {
    position: 'absolute',
    width: '23px',
    height: 'calc(100% + 17px)',
    zIndex: 1,
  },
  greyHeight: {
    color: '#666666',
    paddingBottom: 15,
  },
  tabBar: {
    backgroundColor: theme.palette.background.paper,
    justifyContent: 'flex-start',
  },
  mainTab: {
    backgroundColor: theme.palette.background.paper,
  },
  tabBarArrowButtons: {
    height: 40,
    top: 3,
    width: 40,
  },
  arrowLeft: {
    position: 'absolute',
    left: 0,
  },
  arrowRight: {
    position: 'relative',
    right: 0,
  },
  tab: {
    fontSize: 16,
    fontWeight: 400,
    minWidth: 10,
    padding: 24,
    textTransform: 'capitalize',

    '& span span': {
      padding: 5,
    },

    '@media (min-width: 769px)': {
      '& span span': {
        padding: '5px 10px',
      },
    },

    '@media (min-width: 1281px)': {
      // minWidth: 155,

      '& span span': {
        padding: 'inherit',
      },
    },
  },
  selectedTab: {
    fontWeight: 500,
  },
  inputTab: {
    maxWidth: 135,
  },
  indicator: {},
  addbutton: {
    marginLeft: theme.spacing(2),
    '@media (min-width: 1281px)': {
      '&& span': {
        margin: '0 8px',
      },
    },
  },
  addbuttonZeroState: {
    width: 203,
    height: 48,
    borderRadius: 24,
    margin: '0 auto',
    '@media (min-width: 1281px)': {
      '&& span': {
        margin: '0 9px',
      },
    },
  },
  iconSpacing: {
    marginRight: theme.spacing(1),
    height: 15,
    width: 15,
  },
  verticalDivider: {
    width: 1,
    height: 24,
    borderRadius: 2,
    backgroundColor: theme.palette.border.light,
    marginLeft: 10,
    marginRight: 10,
  },
  appBarGridContainer: {
    display: 'grid',
    alignItems: 'center',
  },
  flexHorizontal: {
    display: 'flex',
    alignItems: 'center',
  },
  labelIcon: {
    width: 32,
    height: 32,
    marginRight: 8,
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'flex-end',
    width: 'fit-content',
  },
  addButton: {
    marginLeft: theme.spacing(2),
  },
});
